<template>
  <div class="row">
    <div v-if="sent" class="alert alert-success mb-2 w-100 text-center">
      {{ t("PW_SENT") }}
    </div>

    <div v-if="showResetForm">
      <div class="row mb-2">
        <div class="col text-center">
          <div class="text16-blue font-italic mb-2">{{ t("RESET_TIP") }}</div>
          <InputText
            type="email"
            :placeholder="t('EMAIL')"
            class="mb-2 w-100"
            v-model="reset.email"
          />
          <InputText
            :placeholder="t('SSN')"
            class="mb-2 w-100"
            v-model="reset.ssn"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col">
          <Button class="enter-btn" :label="t('SEND')" @click="requestPasswordReset()"/>
        </div>
      </div>

      <div class="row">
        <div class="col text-center">
          <Button severity="secondary" :label="t('BACK')" @click="toggleLogin()"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";

const props = defineProps(['showResetForm']);
const route = useRoute();
const axios = injectAxios();
const emit = defineEmits(["hide-form"]);

const { t } = useI18n();

const reset = ref({
  email: null,
  ssn: null,
  account: null,
});

const sent = ref(false);

const toggleLogin = () => {
  reset.value.email = null;
  reset.value.ssn = null;
  emit("hide-form", null);
};

const requestPasswordReset = async () => {
  await axios.post(`/account/reset`, {
    email: reset.value.email,
    ssn: reset.value.ssn,
  });

  sent.value = true;
  reset.value.email = null;
  reset.value.ssn = null;
};
</script>
